import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'ls-avatar-atom',
  standalone: true,
  imports: [AvatarModule, BadgeModule],
  templateUrl: './avatar-atom.component.html',
  styleUrl: './avatar-atom.component.scss',
})
export class AvatarAtomComponent implements OnChanges {
  @Input()
  size?: 'normal' | 'large' | 'xlarge';

  @Input()
  image?: string;

  @Input()
  label?: string;

  imageFailed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['image']) {
      this.imageFailed = false;
    }
  }

  onImageError(): void {
    this.imageFailed = true;
  }
}
